export default __webpack_public_path__ + "static/media/pullman_colin.1f072c4b.jpg";